export default __webpack_public_path__ + "static/media/export_3.402e33c1.png";